import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  CoalescePipe,
  DailySectionStatsPipe,
  DateExtraPipe,
  DateMonthLongNamePipe,
  DateMonthShortNamePipe,
  DatePipe,
  DateShortExtraPipe,
  DateShortPipe,
  DateTimeExtraPipe,
  DateTimePipe,
  DateTinyExtraPipe,
  DateTinyPipe, EmployeeFormatPipe,
  FirstLastNamePipe,
  GroupPrestationVisualsPipe,
  NullIfZeroPipe,
  SortEmployeesPipe,
  TeamFormatPipe,
  TeamCellFormatPipe,
  TeamInArrayPipe,
  TimeExtraPipe,
  TimePipe,
  VisualsPipe
} from '@shared/module/serenity-pipe/pipe';
import {ListItemPipe} from './pipe/ListItem/list-item.pipe';
import {TeamSortInHierarchyPipe} from '@shared/module/serenity-pipe/pipe/TeamSortInHierarchy';
import {GroupSelectPrestationTypePipe} from '@shared/module/serenity-pipe/pipe/GroupSelectPrestationType';
import {EmployeePictureUrlPipe} from "@shared/module/serenity-pipe/pipe/EmployeePictureUrl";


@NgModule({
  declarations: [
    DateExtraPipe,
    DatePipe,
    DateShortExtraPipe,
    DateShortPipe,
    DateTimeExtraPipe,
    DateTimePipe,
    DateTinyExtraPipe,
    DateTinyPipe,
    FirstLastNamePipe,
    TimeExtraPipe,
    TimePipe,
    DateMonthLongNamePipe,
    DateMonthShortNamePipe,
    ListItemPipe,
    TeamFormatPipe,
    TeamCellFormatPipe,
    TeamInArrayPipe,
    TeamSortInHierarchyPipe,
    GroupSelectPrestationTypePipe,
    GroupPrestationVisualsPipe,
    DailySectionStatsPipe,
    NullIfZeroPipe,
    EmployeeFormatPipe,
    VisualsPipe,
    SortEmployeesPipe,
    EmployeePictureUrlPipe,
    CoalescePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DateExtraPipe,
    DatePipe,
    DateShortExtraPipe,
    DateShortPipe,
    DateTimeExtraPipe,
    DateTimePipe,
    DateTinyExtraPipe,
    DateTinyPipe,
    FirstLastNamePipe,
    TimeExtraPipe,
    TimePipe,
    DateMonthLongNamePipe,
    DateMonthShortNamePipe,
    ListItemPipe,
    TeamFormatPipe,
    TeamCellFormatPipe,
    TeamInArrayPipe,
    TeamSortInHierarchyPipe,
    GroupSelectPrestationTypePipe,
    GroupPrestationVisualsPipe,
    DailySectionStatsPipe,
    NullIfZeroPipe,
    VisualsPipe,
    EmployeeFormatPipe,
    SortEmployeesPipe,
    EmployeePictureUrlPipe,
    CoalescePipe
  ]
})
export class SerenityPipeModule {
}
